<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
// 套件
import axios from 'axios'
import moment from 'moment'
// 資料
import Service from './assets/js/data/Service.js'
import APIConfig from './assets/js/data/remote/APIConfig.js'

export default {
  methods: {
    initAxios () {
      const exceptURLs = [
        APIConfig.BPIURL + '/login'
      ]
      const isExcept = (url) => {
        return url.includes('/api') || exceptURLs.indexOf(url) >= 0
      }

      axios.interceptors.request.use(config => {
        if (isExcept(config.url)) return config

        let jwt = config.headers['Authorization'].split('.')
        let exp = JSON.parse(atob(jwt[1])).exp

        config.headers['Content-Encoding'] = 'gzip'

        let isNewToken = Math.floor(Date.now() / 1000) < (exp - 300)
        if (isNewToken) return config

        return this.$services.auth.refresh()
          .then(token => {
            config.headers['Authorization'] = `Bearer ${token}`
            return config
          })
      })

      // axios.interceptors.response.use(null, error => {
      // })
    }
  },
  created () {
    moment.locale('zh-tw')
    Vue.prototype.$services = Service.shared
    this.initAxios()

    let jwt = this.$services.auth.getJWT()
    if (jwt) {
      axios.defaults.headers['Authorization'] = `Bearer ${jwt}`
    }

    this.$router.push({ name: 'launch' })
  }
}
</script>

<style>
@import './assets/css/app.css';
@import './assets/css/common.css';
@import './assets/css/content-editor.css';
@import './assets/css/content-editor-styles.css';

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
